import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ScrollToTopButton from './components/utilities/scroo-to-top';
import { HomePage } from './pages/homepage/hompage';
import { CallButton, WhatsAppButton } from './components/utilities/call-button';
import { SiteFooter } from './components/footer/footer';

import './App.css';
import "./index.css"
import "./styles/header.css";
import "./styles/footer.css";
import { AboutUs } from './pages/about/about';
import { ContactPage } from './pages/contact-form/contact-page';
import { PrivacyPolicy } from './pages/terms-privacy/privacy';
import { TermsAndConditions } from './pages/terms-privacy/terms';
import { ImprintPage } from './pages/terms-privacy/imprint';
import { FourOhFour } from './pages/four-oh-four/not-found';


function App() {
  return (
    <BrowserRouter>
      <ScrollToTopButton />
      <CallButton />
      <WhatsAppButton />
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/about' element={<AboutUs />} />
        <Route path='/contact' element={<ContactPage />} />
        <Route path='/privacy' element={<PrivacyPolicy />} />
        <Route path='/terms' element={<TermsAndConditions />} />
        <Route path='/impressum' element={<ImprintPage />} />
        <Route path='*' element={<FourOhFour />} />
      </Routes>
      <SiteFooter />
    </BrowserRouter>
  );
}

export default App;
